import React from 'react';
import { Navigate } from 'react-router-dom';

const CanUpdateAddressRoute = ({ children }) => {
  const userStr = localStorage.getItem('user');
  const user = JSON.parse(userStr);

  if (!user?.can_update_address) {
    return <Navigate to="/my-orders" replace />;
  }

  return children;
};

export default CanUpdateAddressRoute;
